import { render } from "./ShowListRegisterService.vue?vue&type=template&id=6c9356b0&ts=true"
import script from "./ShowListRegisterService.vue?vue&type=script&lang=ts"
export * from "./ShowListRegisterService.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__